import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const getPreviousScheduleVersion = api(async function previousScheduleVersion({ id, version }) {
    return query(
        gql`
            query PreviousScheduleVersion($id: String!, $version: Int!) {
                previousScheduleVersion(id: $id, version: $version)
            }
        `,
        { id, version },
        { returns: "previousScheduleVersion" }
    )
})
